export default (function () {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    return reducers.reduce(function (p, r) {
      return r.apply(undefined, [p, current].concat(args));
    }, previous);
  };
});


//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/reduce-reducers/es/index.js
// module id = ../../node_modules/reduce-reducers/es/index.js
// module chunks = 8